import * as Model from "../../../../../models";

export function isOnlyOneOptionAllowed(
  customization: Model.Restaurant.Menu.Item.CuratedCustomization
): boolean {
  return customization.max === 1 && customization.min === 1;
}
